import React from 'react'
import Container from 'react-bootstrap/Container'

import Logo from '../../common/images/logo.png'

export default function LoadingPlaceholder() {
    return (
        <div className="text-center" style={{height:"100vh", display:"flex"}}>
            <div className="align-self-center m-auto" style={{width:"fit-content"}}>
                <img width={150} src={Logo} alt="Federico Bartoli PT" style={{maxWidth:"100%"}}></img>
            </div>
        </div>
    )
}